import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button, Icon, Panel, ScreenFrame } from '../ui/index.ts';
import styles from './ComingSoon.module.css';

export function NotFound() {
  const { t } = useTranslation('notFound');
  const navigate = useNavigate();
  return (
    <ScreenFrame title={t('title')} backTo="/">
      <Panel as="div" className={styles['panel']}>
        <Icon name="lock" size="3rem" />
        <p className={styles['body']}>{t('body')}</p>
        <Button
          onClick={() => {
            void navigate('/');
          }}
        >
          {t('home')}
        </Button>
      </Panel>
    </ScreenFrame>
  );
}
